import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

export const IconImg = styled.img``

export const Wrapper = styled.span`
    ${FlexCentered}
    position: absolute;
    background-color: #2c3136;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    padding: 7px;
    top: 1em;
    right: 1em;
    z-index: 1;
    cursor: pointer;

    & > div {
        display: flex;

        & > div {
            margin-top: 20px;
        }
    }
`
